'use client';

import { useSidebar } from "@/context/AdminSidebarContext";


const ToggleMenuButton = () => {
  const { toggleMobileMenu } = useSidebar();

  return (
    <button
      className="lg:hidden p-3 text-xl"
      onClick={() => toggleMobileMenu()}
      aria-label="Toggle menu"
    >
      <svg
        className="w-6 h-6 text-swsPrimary"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  );
};

export default ToggleMenuButton; 
